const unrestrictedSci = "Unrestricted Sci";
const unrestrictedAudience = "Unrestricted Audience";
const unrestrictedDissemination = "Unrestricted Dissemination";

export { unrestrictedSci, unrestrictedAudience, unrestrictedDissemination };